import person from '../common/NewImages/person.svg';
import personGrey from '../common/NewImages/person-grey.svg';

const POLICY_CREATED_FROM_LOGS_DEFAULT_NUMBER = 1;

const PersonsCounter = ({ number = POLICY_CREATED_FROM_LOGS_DEFAULT_NUMBER, disabled = false }) => {
    return (
        <div className={`rounded border-2 py-1 px-2 ${disabled ? 'bg-[#E9ECF4]' : 'bg-[#E9F5FF]'} flex gap-1`}>
            <div className="m-auto">
                <img src={disabled ? personGrey : person} alt="" />
            </div>
            <div className={disabled ? `text-sf-light-700` : ''}>{number.toLocaleString('en-US')}</div>
        </div>
    );
};

export default PersonsCounter;
